<template>
    <div>
        <div class="container">
            <CommonBreadcrumb class="bread_block"/>
            <div class="pdp_flex mt-4">
                <div class="pdp_flex_left">
                     <PresetDetailPresetSlider v-if="images" :images="images"/> 
                      
                </div>
                <div class="pdp_flex_right" v-if="metal">
                    <PresetDetailPresetInfo 
                        :metal="metal" 
                        :options="filterOptions" 
                        :item="settingComponent" 
                        :settingComponent="settingComponent" 
                        :diamonds="settingComponent.diamonds"
                        :activeDiamondVariation="activeDiamondVariation" 
                        @toggleOption="toggleOption"  
                        :sn="metal.id+'D'+activeDiamondVariation.id"
                    />
                </div>
            </div>
        </div>

        <div class="container mt-4 mt-md-5">
            <PresetDetail 
                v-if="settingComponent"
                :settingComponent="settingComponent" 
                :activeDiamondVariation="activeDiamondVariation"
                :description="description"
                :metal="metal"
            />
        </div>
        
        <div class="container mt-4 mt-md-5" v-if="$country.payment_banner">
            <CommonPaymentBanner />
        </div>

        <!-- <div class="container mt-4 mt-md-5">
            <CyoSettingSimilarSettings />
        </div> -->

        <div class="container mt-4 mt-md-5" v-if="$country.evertreen">
            <EvertreeBanner/>
        </div>

        <div class="container mt-4 mt-md-5" v-if="$country.trustpilot">
            <HomeTrustpilotReview />
        </div>

    </div>
</template>

<script setup>
    import { useSeo } from '@/composables/seo/setMetaTags'
    const tags = useSeo();

    const localePath = useLocalePath();
    const route = useRoute()
    const router = useRouter()

    const settingComponent = ref(null)
    const description = ref("")
    const filterOptions = reactive({
        metals: [],
        shape: [],
        weight: [],
        cen_stone_quality: [],
        size: []
    })
    const meta = ref({ })
    let activeDiamondVariation = ref([])

    const metal = computed(() => {
        return filterOptions.metals.find(item => item.selected === 1)
    })

    const shape = computed(() => {
        return filterOptions.shape.find(item => item.selected === 1)
    })

    const weight = computed(() => {
        return filterOptions.weight.find(item => item.selected === 1)
    })

    const cen_stone_quality = computed(() => {
        return filterOptions.cen_stone_quality.find(item => item.selected === 1)
    })

    const images = computed(() => {
        let imgObj = null
        if(metal!== undefined && settingComponent.value?.all_images && shape !== undefined) {

            const response = settingComponent.value.all_images.find(item => item.color === metal.value.icon)
            Object.keys(response.images).forEach(function(key){
                if(response.images[key] === null) {
                    delete( response.images[key] )
                }
            });
            imgObj = { front_image : response.shapes[shape.value.value], ...response.images }
        }
        return imgObj
    })

    const price = computed(() => {
        return metal.value ? metal.value.values.price + activeDiamondVariation.value.price : 0
    }) 
    
    function extractOptions() {
        // metal options
        const metalIds = new Set();
        filterOptions.metals = settingComponent.value.metals
        .filter(item => item.availability === 1)
        .filter(item => {
            if (!metalIds.has(item.metal)) {
                metalIds.add(item.metal);
                return true;
            }
            return false;
        })
        .map((item) => ({
            id: item.id,
            value: item.metal,
            label: item.label,
            selected: item.metal === settingComponent.value.metal ? 1 : 0,
            icon: item.color,
            values:{...item}
        }));
       

        //shape options
        const shapeIds = new Set();
        filterOptions.shape = settingComponent.value.preset_diamonds
        .filter(item => {
            if (!shapeIds.has(item.shape)) {
                shapeIds.add(item.shape)
                return true;
            }
            return false;
        })
        .map((item) => ({
            id : item.id,
            value: item.shape,
            label: item.shape,
            selected : item.shape === settingComponent.value.preset_diamond.shape ? 1 : 0,
            icon : item.shape
        }))


        //carat options
        const caratIds = new Set();
        filterOptions.weight = settingComponent.value.preset_diamonds
        .filter(item => {
            if (!caratIds.has(item.weight)) {
                caratIds.add(item.weight)
                
                return true;
            }
            return false
        })
        .map((item) => ({
            id: item.id,
            value : item.weight,
            label: item.weight+' ct',
            selected : item.weight === settingComponent.value.preset_diamond.weight ? 1 : 0,
            icon : null
        }))
        //  console.log(settingComponent.value.preset_diamond.weight ? 1 : 0, weight,filterOptions.weight, 'huh'); //done

        ////quality options
        const qualityIds = new Set();
        filterOptions.cen_stone_quality = settingComponent.value.preset_diamonds
        .filter(item => {
            if (!qualityIds.has(item.color + '/' + item.clarity)) {
                qualityIds.add(item.color + '/' + item.clarity);
                // console.log(item.color+'/'+item.clarity,'ppp');
                return true;
            }
            return false;
        })
        .map ((item)=>({
            id: item.id,
            value : item.color + '/' + item.clarity,
            label : item.color_label + '-' + item.clarity_label,
            selected : (item.color === settingComponent.value.preset_diamond.color) 
            && (item.clarity === settingComponent.value.preset_diamond.clarity)  ? 1 : 0,
            icon: null
        }))
    
        filterOptions.size = settingComponent.value.size.filter(item => item.visibility = 1)
    }

    function getActiveVariation() {
        const data = settingComponent.value.preset_diamonds
        .find(obj => obj.shape === shape.value.value &&
            obj.weight === weight.value.value &&
            obj.color + '/' + obj.clarity === cen_stone_quality.value.value && 
            obj.approved === 1
            )
        activeDiamondVariation.value = data;
    }

    const { data, pending, refresh, error } = await useFetch(useCountryPath('/config/setting/preset/detail/' + route.params.slug))
    
    // watch(data, async(detailData) => {
        
    //     settingComponent.value = detailData.data;

    //     extractOptions()
    //     getActiveVariation()

        
    //     await getDescription()
    //     await getMetaTags() 
    //     await prepareMetaTags() 
    // })


    if (data.value?.success) {
        settingComponent.value = data.value.data;
   
        extractOptions()
        getActiveVariation()

       
        await getDescription()
        await getMetaTags() 
        await prepareMetaTags() 
    }

    if(error.value){
        if(error.value.statusCode === 404 || error.value.statusCode === 400) {
            router.push(localePath({ name: 'preset-listing'}))
        }
    }


    async function getMetaTags(){
                
        let sn = route.params.slug.substring( route.params.slug.lastIndexOf('-') + 1 )
        if( import.meta.client){

            sn = window.location.pathname.substring( window.location.pathname.lastIndexOf('-') + 1 )
        }

        const res = await $fetch(useCountryPath(`/config/setting/preset/meta-description/${sn}`))
        if(res.success) {
            meta.value = { ...res.data }
        }
    }
        
    async function prepareMetaTags(){
        if( ! meta.value.meta_title){
            
            return
        }

        const object = {
            ...meta.value,
            sn: metal.value.id+'D'+activeDiamondVariation.value.id,
            settingComponent : settingComponent.value,
            metal: metal.value,
            images: images.value,
            price: price.value
        }
        
        await tags.setMetaTags(object)

    }

    function toggleOption()  {
        getActiveVariation()     
        updateUrl()
        getDescription()
        getMetaTags().then( () => prepareMetaTags() )
    }

    async function getDescription()  {

        let sn = route.params.slug.substring(route.params.slug.lastIndexOf('-') + 1)
        if(import.meta.client) {
            sn = window.location.pathname.substring( window.location.pathname.lastIndexOf('-') + 1 )
        }
        try {
            const response = await $fetch(useCountryPath('/setting/preset/product-description/' + sn));

            if (response && response.data) {
                description.value = response.data.description;
            } else {
                throw new Error('No description data found');
            }
        } catch (error) {
            // Optionally, you can handle specific FetchErrors differently
            if (error.name === 'FetchError') {
                console.log('Fetch error occurred:', error.message);
            }

            // Show a user-friendly message or perform fallback logic
            description.value = 'Failed to load product description';
        }

    }


    function updateUrl() {
        const slug = metal.value.values.slug.substring(0,metal.value.values.slug.lastIndexOf('-'));
        const url = '/preset-engagement-rings/'+slug+'-'+metal.value.id+'D'+ activeDiamondVariation.value.id
        history.pushState({}, "/",localePath(url));
        return
    }

    onMounted(() => {
        if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
            cls_InovaDiamonds_Iframe.init_Session_Go()
        }
        
        const script = document.createElement('script');
        script.src = 'https://vto.jewelry/?d=6LYC9UW';
        script.async = true;
        script.onload = () => {
        };
        document.head.appendChild(script);
    })

   


</script>


<style scoped>
@media (min-width: 768px) {
    .sticky_box {
        height: fit-content;
        position: sticky;
        top: 20px;
    }
}

@media(max-width: 767px) {
    .detail-container-min-height {
        min-height: 47vh;
    }
}

@media(max-width: 992px) {
    .for_desktop {
        display: none;
    }
}

@media(max-width: 768px) {
    .sliderthumbs {
        display: none;
    }

    .for_desktop {
        display: none;
    }
}

.for_desktop_mod {
    display: none;
}

@media (min-width: 767px) and (max-width: 1024px) {
    .for_desktop_mod {
        display: block !important;
    }

}
</style>